<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <svg
    role="img"
    width="100%"
    height="100%"
    :aria-labelledby="titleId"
    :viewBox
    preserveAspectRatio="none"
  >
    <title :id="titleId">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      :clip-path="`url(#${clipPathId})`"
      :style="`fill: url(#${fillId});`"
    />
    <defs>
      <clipPath :id="clipPathId">
        <slot />
      </clipPath>
      <linearGradient :id="fillId">
        <stop
          offset="0.599964"
          stop-color="#ededed"
          stop-opacity="1"
        >
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="1.59996"
          stop-color="#d1d1d2"
          stop-opacity="1"
        >
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="2.59996"
          stop-color="#ededed"
          stop-opacity="1"
        >
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { useId } from 'vue';

interface LoaderSkeletonProps {
  /** SVG viewBox attribute defining coordinate system and aspect ratio */
  viewBox?: string;
}

withDefaults(defineProps<LoaderSkeletonProps>(), {
  viewBox: '0 0 800 124',
});

// Generate unique IDs to avoid conflicts when multiple skeletons render on the same page
const titleId = `title-${useId()}`;
const clipPathId = `clipPath-${useId()}`;
const fillId = `fill-${useId()}`;
</script>
